var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurgerMenu = function SvgBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 35
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "burger-menu_svg__a",
    d: "M0 0h39.443v35H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "burger-menu_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#burger-menu_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F17900",
    d: "M28.018 35H11.426a3.14 3.14 0 0 1-2.711-1.564L.418 19.065a3.14 3.14 0 0 1 0-3.13l.973-1.685a1 1 0 0 1 1.732 1l-.972 1.685a1.13 1.13 0 0 0-.001 1.13l8.297 14.37c.2.348.576.565.979.565h16.592c.403 0 .778-.216.979-.565l8.296-14.37a1.13 1.13 0 0 0 0-1.13l-8.296-14.37a1.13 1.13 0 0 0-.98-.565h-16.59c-.403 0-.778.217-.98.566L9.474 4.25a1 1 0 0 1-1.732-1l.972-1.685A3.14 3.14 0 0 1 11.426 0h16.592c1.115 0 2.154.6 2.71 1.565l8.298 14.37a3.14 3.14 0 0 1 0 3.13l-8.297 14.37A3.14 3.14 0 0 1 28.018 35",
    mask: "url(#burger-menu_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F17900",
    d: "M23.554 9.75H5.527a1 1 0 1 1 0-2h18.027a1 1 0 0 1 0 2m0 6H11.087a1 1 0 0 1 0-2h12.467a1 1 0 0 1 0 2"
  }))));
};
export default SvgBurgerMenu;